// extracted by mini-css-extract-plugin
export default {"wrapper":"GridShortcutButtons_wrapper__ePcsu"};